import { render } from "./ReplacementItemList.vue?vue&type=template&id=41e681a2&scoped=true&bindings={}"
import script from "./ReplacementItemList.vue?vue&type=script&lang=ts"
export * from "./ReplacementItemList.vue?vue&type=script&lang=ts"

import "./ReplacementItemList.vue?vue&type=style&index=0&id=41e681a2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-41e681a2"

export default script